export { default as wrapComponentWith } from './wrapComponentWith';
